import styled from "styled-components";

export const Raiz = styled.div`
  width: 100%;
  min-width: 0;

  /* ---- Estreita: cartão empilhado ---- */
  &.estreita{
    .cabecalho{ display: none; }

    .linha{
      display: flex;
      flex-direction: column;
      gap: 6px;
      padding: 14px 0;
      border-bottom: 1px solid #EFF0F2;
    }

    /* O rótulo só aparece fora da primeira célula (que é a identificação). */
    .celula:not(:first-child) .rotulo-celula{
      display: block;
      margin-bottom: 2px;
      font-size: 10px;
      font-weight: 700;
      text-transform: uppercase;
      letter-spacing: .04em;
      color: #6B6E70;
    }
  }

  .celula .rotulo-celula{ display: none; }

  .celula{ min-width: 0; }

  /* ---- Larga: UMA grade para a tabela inteira ----
     Se cada linha fosse uma grade própria, colunas de largura automática
     (a das ações, que muda conforme os botões) ficariam diferentes de uma linha
     para outra e desalinhadas do cabeçalho. Com as linhas em display: contents,
     todas as células participam da mesma grade e as colunas alinham sempre. */
  &.larga{
    display: grid;
    grid-template-columns: var(--colunas);
    column-gap: 0;
    align-items: center;

    .cabecalho,
    .linha{
      display: contents;
    }

    /* Sem column-gap: o respiro entre colunas é padding das células, para a
       borda horizontal ser CONTÍNUA (com gap ela ficaria cortada). */
    .cabecalho > span{
      padding: 8px 10px;
      border-bottom: 2px solid #E1E3E6;
      font-size: 11px;
      font-weight: 700;
      text-transform: uppercase;
      letter-spacing: .04em;
      color: #4D4F50;
    }

    .linha > .celula{
      padding: 12px 10px;
      border-bottom: 1px solid #EFF0F2;
      align-self: stretch;
      display: flex;
      align-items: center;
    }

    .linha:hover > .celula{ background: #FAFBFA; }

    /* A grade não tem padding lateral (as bordas iriam até a borda do bloco):
       o respiro vem da primeira e da última célula. */
    .cabecalho > span:first-child,
    .linha > .celula:first-child{ padding-left: 12px; }
    .cabecalho > span:last-child,
    .linha > .celula:last-child{ padding-right: 12px; }

    .direita{ text-align: right; justify-content: flex-end; }

    .vazio-tabela{ grid-column: 1 / -1; }
  }

  .vazio-tabela{
    padding: 28px 0;
    text-align: center;
    font-size: 13px;
    color: #4D4F50;
  }
`;
